var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"empty-view"},[_c('img',{staticClass:"empty-view-cover",attrs:{"src":_vm.$images.guide_wenfang_empty_bg}}),_vm._v(" "),_c('div',{staticClass:"empty-view-text"},[_vm._v("文房要准备些什么呢？")])])
}
var staticRenderFns = []

export { render, staticRenderFns }